import React from 'react';
import { Box } from '@mui/material';
import { type ResizeHandleAxis } from 'react-grid-layout';
import ReactGridContainer from '../ReactGridContainer/ReactGridContainer';

type ReactGridContainerWithChildrensProps = {
    localStorageName: string;
    childrens: { key: string; component: React.ReactNode }[];
    maxIndexCard?: number;
    rowHeight?: number;
    cols?: number;
    showResetButton?: boolean;
};

const ReactGridContainerWithChildrens: React.FunctionComponent<ReactGridContainerWithChildrensProps> =
    function ({
        localStorageName,
        childrens,
        maxIndexCard = 5,
        rowHeight = 250,
        cols = 5,
        showResetButton = true,
    }) {
        return (
            <ReactGridContainer
                localStorageName={localStorageName}
                gridconfig={{ cols, rowHeight }}
                layoutProps={childrens.map((widget, i) => ({
                    i: widget.key,
                    x: i % maxIndexCard,
                    y: Math.floor(i / maxIndexCard),
                    w: 1,
                    h: 1,
                    isResizable: true,
                    resizeHandles: [
                        's',
                        'w',
                        'e',
                        'n',
                        'sw',
                        'nw',
                        'se',
                        'ne',
                    ] as ResizeHandleAxis[],
                }))}
                showResetButton={showResetButton}
            >
                {childrens &&
                    childrens.map((widget) => (
                        <Box
                            key={widget!.key as string}
                            sx={{ height: '100%' }}
                        >
                            {widget.component}
                        </Box>
                    ))}
            </ReactGridContainer>
        );
    };

export default ReactGridContainerWithChildrens;
